import PriceDetails from './PriceDetails';
import { PaymentManagerContainer } from '../paymentManager.styles';
import PaymentMethodDetails from './PaymentMethodDetails';
import { useEffect, useState } from 'react';
import { get_billing_info } from '../PaymentLambdaUtils';
import { message } from 'antd';
import { CardDetails, RateDetails } from '../PaymentManagerType';

const BillingInfo = () => {
    const [priceRates, setPriceRates] = useState<RateDetails | null>(null);
    const [loadingRate, setLoadingRate] = useState<boolean>(true);
    const [cardDetails, setCardDetails] = useState<CardDetails | null>(null);

    useEffect(() => {
        get_billing_info()
            .then((resp: string) => {
                const data = JSON.parse(resp);
                setPriceRates(data?.rates);
                setCardDetails(data?.billing_info?.stripe);
            })
            .catch((err) => {
                message.error("Failed to fetch rates");
                console.log(err);
            })
            .finally(() => {
                setLoadingRate(false)
            });
    }, []);

    return (
        <PaymentManagerContainer>
            <div className='billing_block'>
                <PriceDetails priceRates={priceRates} loadingRate={loadingRate} />
                <PaymentMethodDetails cardDetails={cardDetails} loadingRate={loadingRate} />
            </div>
        </PaymentManagerContainer>
    );
}

export default BillingInfo;
